import type { ReactNode } from 'react';
import { CameraOutlined, FileImageOutlined } from '@ant-design/icons';
import { Capacitor } from '@capacitor/core';
import { Dropdown, Modal, Upload } from 'antd';
import type { MenuProps } from 'antd';

import { ReactComponent as ProfileIcon } from 'assets/icons/eiq-connect/profile.svg';
import { useUploadPhoto } from 'common/hooks/use-upload-photo/use-upload-photo';

import './profile-photo-upload.scss';

interface IUploadProfilePhotoProps {
  hook: ReturnType<typeof useUploadPhoto>;
  uploadText: ReactNode;
}

export const UploadProfilePhoto = ({ hook, uploadText }: IUploadProfilePhotoProps) => {
  const isNative = Capacitor.isNativePlatform();
  const { Dragger } = Upload;

  const items: MenuProps['items'] = [
    {
      key: 'camera',
      label: 'Take a Photo',
      icon: <CameraOutlined />,
      onClick: () => void hook.takePicture(),
    },
    {
      key: 'gallery',
      label: 'Photo Library',
      icon: <FileImageOutlined />,
      onClick: () => void hook.selectFromGallery(),
    },
  ];

  return (
    <div className="upload-profile-photo-wrapper">
      <Dragger {...hook.uploadProps} openFileDialogOnClick={!isNative}>
        {isNative ? (
          <Dropdown menu={{ items }} trigger={['click']}>
            <div className="upload-profile-photo-wrapper-android upload-profile-photo-wrapper-native">
              <div className="profile-icon-wrapper">
                <ProfileIcon />
              </div>
              <div className="upload-text">{uploadText}</div>
            </div>
          </Dropdown>
        ) : (
          <>
            <div className="profile-icon-wrapper">
              <ProfileIcon />
            </div>
            <div className="upload-text">{uploadText}</div>
          </>
        )}
      </Dragger>

      <Modal open={hook.previewOpen} footer={null} onCancel={() => hook.setPreviewOpen(false)}>
        <img alt="Profile photo preview" src={hook.previewImage} style={{ width: '100%' }} />
      </Modal>
    </div>
  );
};
